import React, { Component } from 'react';
import TableKPI from './TableKPI'
import { getDataTab } from '../../components/UserFunctions'

class AEB extends Component {
  state = {
    data: []
  }
  componentDidMount() {
    const url = (window.location.origin).concat('/get_data_tab')
    const payload = { name: 'AEB' }
    getDataTab(url, payload).then(response => {
      if (response) {
          if (response.status === 200) {
                    this.setState((prevState) =>({data : response.data.data}))
        }
      }
    })
  }

  render() {
    return (
      <div data-test = 'kpiManagerAEBComponent'>
        <TableKPI data={this.state.data} name={"AEB"} />
      </div>
    )
  }

}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default AEB;

